import { styled } from "@mui/material/styles";
import { colors } from "../../constants/colors";
import { Box, Typography } from "@mui/material";

export const LayoutMainStyle = styled(Box)(({ theme }) => ({
    display: 'flex',
    '.active': {
        width: "80px",
        transition: '.5s'
    }
}))
export const LayoutView = styled(Box)(({ theme }) => ({
    maxWidth: "1440px",
    margin: "48px auto",
    [theme.breakpoints.down('lg')]: {
        margin: '48px'
    }

}))
export const LayoutTitle = styled(Box)(({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: "32px",
    flexDirection:"row",
    [theme.breakpoints.down('lg')]: {
        flexDirection:'column',
    }
}))
export const TitleText = styled(Typography)(({ theme }) => ({
    fontSize: '28px',
    fontWeight: 500,
    color: colors.themeMainColor,
    lineHeight: '42px',
    letterSpacing: '0px',
}))

